import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtSectionButton from "../general/NtSectionButton";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";
import { useNavigation } from "@react-navigation/native";
import routes from "../../../navigation/routes";

function NtIntegratedHotelSection({ showLearnMore = true }) {
  const isMobile = useMobile();
  const nav = useNavigation();
  const renderBox = (icon, text, containerStyle) => {
    return (
      <View
        style={[
          {
            borderColor: "#5584c4",
            borderRadius: 10,
            borderWidth: 1,
            backgroundColor: "rgba(17, 116, 255, 0.2)",
            padding: 20,
            backdropFilter: "blur(8px)",
            width: 170,
            alignItems: "center",
          },
          containerStyle,
        ]}
      >
        <NtMaterialIcon name={icon} color="white" size={28} />
        <NtText
          style={{
            color: "white",
            fontSize: 11,
            fontWeight: "600",
            marginTop: 8,
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/70ad0b3feabae50667188be2880da155e50b5b14.png")}
    >
      <View
        style={{
          flex: 1,
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: isMobile ? "center" : "flex-end",
          paddingBottom: 30,
        }}
      >
        <View
          style={{
            flex: isMobile ? -1 : 1,
            padding: 20,
            alignItems: "flex-start",
          }}
        >
          <NtSectionTitle style={{ textAlign: "left" }}>
            INTEGRATED HOTEL & GUEST COMMUNICATION EXPERIENCE
          </NtSectionTitle>

          {showLearnMore && (
            <NtSectionButton
              containerStyle={{ marginTop: 20 }}
              color="white"
              title="Learn More"
              onPress={() => {
                nav.navigate(routes.hospitality);
              }}
            />
          )}
        </View>
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {renderBox("phone-in-talk", "Hotel to Guest Calling", {
              marginRight: 10,
            })}
            {renderBox("bitcoin", "Increase Revenue")}
          </View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            {renderBox("cellphone-sound", "Guest Can BYOD", {
              marginRight: 10,
            })}
            {renderBox("speedometer-slow", "Low cost Solution")}
          </View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            {renderBox("chart-bar", "Increase Engagement", {
              marginRight: 10,
            })}
            {renderBox("account-group", "Guest to Guest Calling")}
          </View>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 500,
  },
});

export default NtIntegratedHotelSection;
